<template>
  <div>
    <v-row justify="start" justify-md="space-around" justify-lg="start" >
      <v-col cols="12" md="10" lg="6">
        <ManageMaintenanceRequest v-if="isNew !== null"  :isNew="isNew" :id="$props.id"></ManageMaintenanceRequest>
      </v-col>
      <v-col cols="12" md="10" lg="6">
        <MaintenanceRequestsList :editMode="true"></MaintenanceRequestsList>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ManageMaintenanceRequest from "../components/Maintenance/ManageMaintenanceRequest";
import MaintenanceRequestsList from "../components/Maintenance/MaintenanceRequestsList";
import { mapActions, mapGetters } from "vuex";

export default {
  name: 'MaintenanceRequests',
  components: {
    MaintenanceRequestsList,
    ManageMaintenanceRequest
  },
  data: () => ({
    isNew: null,
  }),
  props: {
    id: {
      type: String,
      default: null
    },
  },
  methods:{
    async initialize() {
      await this.setMaintenanceRequest(this.$props.id);
      if (this.$props.id !== this.maintenanceRequestID){
        //id doesn't exist, so default to main reminder page
        await this.$router.push('/maintenance-requests');
      }
      this.isNew = !(this.maintenanceRequestID);

    },
    ...mapActions([
      'setMaintenanceRequest',
    ]),

  },
  computed: {
    ...mapGetters([
      'maintenanceRequestID',
      'maintenanceRequests'
    ]),
  },
  created() {
    this.initialize();
  },
  watch: {
    '$route.params.id': function () {
      this.initialize();
    },
  },


}
</script>

<style lang="scss" scoped>

</style>